module.exports = __webpack_public_path__ + "static/paint-2-fc081b56780dbabf7111bb9911d3981f.png";